/**
 * Shared IndexedDB constants for task and structure caches.
 */

export const DB_NAME = 'zenda-tasks-cache';
export const DB_VERSION = 5;
